// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"VideoPlayer_videoContainer__3oU-6","iframe":"VideoPlayer_iframe__1hITH","videoDescription":"VideoPlayer_videoDescription__35_Ps"};